import { render, staticRenderFns } from "./SceneEditor.vue?vue&type=template&id=5e80cbc7&scoped=true"
import script from "./SceneEditor.vue?vue&type=script&lang=js"
export * from "./SceneEditor.vue?vue&type=script&lang=js"
import style0 from "./SceneEditor.vue?vue&type=style&index=0&id=5e80cbc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e80cbc7",
  null
  
)

export default component.exports